import React from "react";
import { Helmet } from "react-helmet";
import config from "../config";

export default function GTMHelmet() {
  return (
    <>
      <Helmet>
        {/* Google Tag Manager */}
        <script>
          {`
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${config.gtmId}');
          `}
        </script>
        {/* End Google Tag Manager */}
      </Helmet>

      {/* Google Tag Manager (noscript) */}
      <noscript>
        <iframe title={`${config.gtmId}-noscript`} src={`https://www.googletagmanager.com/ns.html?id=${config.gtmId}`} height="0" width="0" style={{ display: "none", visibility: "hidden" }} />
      </noscript>
    </>
  );
}
